import React, { memo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import TooltipWrapper from "../../enhancers/TooltipWrapper";
import { AnalysisStatus } from "../../lib/enums";
import ClassificationPlaceholderIcon from "./ClassificationPlaceholderIcon";
import RenderWhen from "../RenderWhen";
import ProcessingIcon from "./ProcessingIcon";
import Icon from "../Icon";

interface IClassificationInfoIconProps {
  classification?: number | string;
  processingStateMessage?: string;
  style?: React.CSSProperties;
}

const getTooltipMessage = (
  classification?: number | string,
  processingStateMessage?: string
) => {
  switch (classification) {
    case AnalysisStatus.PROCESSING:
      return "Queued for processing";
    case AnalysisStatus.REANALYZING:
      return "Queued for processing";
    case "error":
      return `Last analysis finished with error: ${processingStateMessage}`;
    default:
      return undefined;
  }
};

const ClassificationInfoIcon = ({
  classification,
  processingStateMessage,
  style
}: IClassificationInfoIconProps) => {
  const tooltipMessage = getTooltipMessage(
    classification,
    processingStateMessage
  );

  if (!tooltipMessage) {
    return <ClassificationPlaceholderIcon style={style} />;
  }

  return (
    <TooltipWrapper
      condition
      wrapper={(children: JSX.Element) => (
        <OverlayTrigger
          overlay={<Tooltip key={tooltipMessage}>{tooltipMessage}</Tooltip>}
          placement="bottom"
          trigger={["hover", "focus"]}
          rootClose
        >
          <span>{children}</span>
        </OverlayTrigger>
      )}
    >
      <RenderWhen
        condition={
          classification === AnalysisStatus.PROCESSING ||
          classification === AnalysisStatus.REANALYZING
        }
        fallback={
          <Icon name="error-i" style={{ ...style, paddingTop: "4px" }} />
        }
      >
        <ProcessingIcon style={style} />
      </RenderWhen>
    </TooltipWrapper>
  );
};

export default memo(ClassificationInfoIcon);
